/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './sexual-history.reducer';

export const SexualHistory = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const sexualHistoryList = useAppSelector(state => state.sexualHistory.entities);
  const loading = useAppSelector(state => state.sexualHistory.loading);
  const totalItems = useAppSelector(state => state.sexualHistory.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="sexual-history-heading" data-cy="SexualHistoryHeading">
        <Translate contentKey="tinyMedicRestApp.sexualHistory.home.title">Sexual Histories</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.sexualHistory.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/sexual-history/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.sexualHistory.home.createLabel">Create new Sexual History</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.sexualHistory.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {sexualHistoryList && sexualHistoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('solo')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.solo">Solo</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('solo')} />
                </th>
                <th className="hand" onClick={sort('partner')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.partner">Partner</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('partner')} />
                </th>
                <th className="hand" onClick={sort('currMethod')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.currMethod">Curr Method</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('currMethod')} />
                </th>
                <th className="hand" onClick={sort('currMethodSatisfaction')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.currMethodSatisfaction">Curr Method Satisfaction</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('currMethodSatisfaction')} />
                </th>
                <th className="hand" onClick={sort('pastMethodHistory')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.pastMethodHistory">Past Method History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pastMethodHistory')} />
                </th>
                <th className="hand" onClick={sort('sexuallyActive')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.sexuallyActive">Sexually Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sexuallyActive')} />
                </th>
                <th className="hand" onClick={sort('activeNumPartners')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.activeNumPartners">Active Num Partners</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('activeNumPartners')} />
                </th>
                <th className="hand" onClick={sort('newPartnerInThreeMonths')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.newPartnerInThreeMonths">New Partner In Three Months</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('newPartnerInThreeMonths')} />
                </th>
                <th className="hand" onClick={sort('contraception')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.contraception">Contraception</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('contraception')} />
                </th>
                <th className="hand" onClick={sort('historyOfSexualAbuse')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.historyOfSexualAbuse">History Of Sexual Abuse</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historyOfSexualAbuse')} />
                </th>
                <th className="hand" onClick={sort('abuseComments')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.abuseComments">Abuse Comments</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('abuseComments')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.sexualHistory.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {sexualHistoryList.map((sexualHistory, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/sexual-history/${sexualHistory.id}`} color="link" size="sm">
                      {sexualHistory.id}
                    </Button>
                  </td>
                  <td>{sexualHistory.solo ? 'true' : 'false'}</td>
                  <td>{sexualHistory.partner ? 'true' : 'false'}</td>
                  <td>{sexualHistory.currMethod}</td>
                  <td>{sexualHistory.currMethodSatisfaction}</td>
                  <td>{sexualHistory.pastMethodHistory}</td>
                  <td>{sexualHistory.sexuallyActive ? 'true' : 'false'}</td>
                  <td>{sexualHistory.activeNumPartners}</td>
                  <td>{sexualHistory.newPartnerInThreeMonths ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ContraceptionType.${sexualHistory.contraception}`} />
                  </td>
                  <td>{sexualHistory.historyOfSexualAbuse ? 'true' : 'false'}</td>
                  <td>{sexualHistory.abuseComments}</td>
                  <td>{sexualHistory.active ? 'true' : 'false'}</td>
                  <td>{sexualHistory.draft ? 'true' : 'false'}</td>
                  <td>{sexualHistory.cursor}</td>
                  <td>{sexualHistory.lastUpdated}</td>
                  <td>{sexualHistory.microSec}</td>
                  <td>{sexualHistory.timestampEntry}</td>
                  <td>
                    {sexualHistory.patient ? <Link to={`/gluco-user/${sexualHistory.patient.id}`}>{sexualHistory.patient.id}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/sexual-history/${sexualHistory.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/sexual-history/${sexualHistory.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/sexual-history/${sexualHistory.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.home.notFound">No Sexual Histories found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={sexualHistoryList && sexualHistoryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default SexualHistory;
